// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { connect } from 'react-redux';
import BagPageSelector, {
  getFreeShippingType,
  isPickuOrderStatus,
} from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.selectors';
import bagPageActions from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.actions';
import { getLedgerSummaryData } from '@tcp/core/src/components/features/CnC/common/organism/OrderLedger/container/orderLedger.selector';
import selectors from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.selector';
import {
  getUserLoggedInState,
  getUserName,
  getUserLastName,
} from '@tcp/core/src/components/features/account/User/container/User.selectors';
import CHECKOUT_ACTIONS, {
  checkoutWithAfterPay,
  getSetShippingValuesActn,
  updateSelectedShippingMethod,
  checkoutWithExpressAfterPay,
  setAfterPayPaymentProgress,
  setAfterPayDrawer,
  getSetPickupValuesActn,
} from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.action';
import CHECKOUT_CONSTANTS from '@tcp/core/src/components/features/CnC/Checkout/Checkout.constants';
import { setSpcButtonLoader } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.actions';
import * as PickupSelectors from '@tcp/core/src/components/common/organisms/ProductPickup/container/ProductPickup.selectors';
import setLoaderState from '@tcp/core/src/components/common/molecules/Loader/container/Loader.actions';
import { setClickAnalyticsData, trackClick } from '@tcp/core/src/analytics/actions';
import {
  getAllCoupons,
  getAppliedCouponListState,
  isCouponApplied,
} from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/container/Coupon.selectors.js';
import {
  getAfterPayMinOrderAmount,
  getAfterPayMaxOrderAmount,
  getFreeShippingThershold,
  getDynamicShippingCharge,
  getDynamicShippingTax,
  getIsShippingChargesApplicableForAfterPayEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { DUMMY_ADDRESS_VALUES_FOR_AFTER_PAY } from '@tcp/core/src/components/common/organisms/AfterPayPayment/AfterPay.constants';
import {
  updateAppStatusAction,
  updateAppTokensAction,
  updateAppCreditCardInfoAction,
} from './AfterPay.actions';
import * as AfterPaySelectors from './AfterPay.selectors';

import AfterPay from '../views/AfterPay.view';
import AfterPayExpress from '../views/AfterPayExpress.view';
import { removeCoupon } from '../../../../features/CnC/common/organism/CouponAndPromos/container/Coupon.actions';
import BAGPAGE_CONSTANTS from '../../../../features/CnC/BagPage/BagPage.constants';
import { getOrderShipments } from '../../../../features/CnC/CartItemTile/container/CartItemTile.selectors';

const AfterPayContainer = (props) => {
  const {
    isExpressPayment,
    selectedShippingMethod,
    shippingAddressObj,
    shippingAddressState,
    errorOnRemoveApi,
    successOnRemoveCouponApi,
    isPlccPostApplicationExperienceEnabled,
    freeShippingPromoType,
    shipments,
    shippingMethodSelected,
    freeShippingThreshold,
    ledgerSummaryData,
    isShippingChargesApplicableForAfterPayEnabled,
    cardType,
  } = props;

  const { shippingTotal } = ledgerSummaryData;
  const shipmentsObject = shipments && JSON.parse(JSON.stringify(shipments));
  const shippingDetails = shipmentsObject?.filter(
    (shipment) => shipment?.c_fromStoreId === null
  )[0];

  const shippingMethodCodeSelected =
    shippingMethodSelected?.code || shippingDetails?.shippingMethod?.c_code;

  const isShippingMethodApplicableForFreeShipping = BAGPAGE_CONSTANTS.FREE_SHIPMENT_CODES?.includes(
    shippingMethodCodeSelected
  );
  const STHValue = shippingDetails?.productTotal;
  const STHCartValueLesserThanThreshold = STHValue !== 0 && STHValue < freeShippingThreshold;

  const placeCard = 'PLACE CARD';

  const isADSPaymentPresent =
    freeShippingPromoType === 'plcc' || cardType === placeCard || cardType?.includes(placeCard);

  const isUserEligibleForShippingCharges =
    isShippingChargesApplicableForAfterPayEnabled &&
    isADSPaymentPresent &&
    isShippingMethodApplicableForFreeShipping &&
    STHCartValueLesserThanThreshold &&
    shippingTotal === 0;

  return isExpressPayment &&
    (selectedShippingMethod === undefined ||
      selectedShippingMethod === CHECKOUT_CONSTANTS.SHIPPING_CODE.UGNR ||
      shippingAddressObj?.emailAddress === DUMMY_ADDRESS_VALUES_FOR_AFTER_PAY.email ||
      !shippingAddressState) ? (
    <AfterPayExpress
      isExpressAfterPayPayment={isExpressPayment}
      errorOnRemoveApi={errorOnRemoveApi}
      successOnRemoveCouponApi={successOnRemoveCouponApi}
      isPlccPostApplicationExperienceEnabled={isPlccPostApplicationExperienceEnabled}
      isUserEligibleForShippingCharges={isUserEligibleForShippingCharges}
      {...props}
    />
  ) : (
    <AfterPay
      isExpressAfterPayPayment={isExpressPayment}
      errorOnRemoveApi={errorOnRemoveApi}
      successOnRemoveCouponApi={successOnRemoveCouponApi}
      isPlccPostApplicationExperienceEnabled={isPlccPostApplicationExperienceEnabled}
      isUserEligibleForShippingCharges={isUserEligibleForShippingCharges}
      {...props}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    cartOrderItems: BagPageSelector.getOrderItems(state),
    ledgerSummaryData: getLedgerSummaryData(state),
    shippingAddress: selectors.getShippingAddress(state),
    shippingPhoneAndEmail: selectors.getShippingPhoneAndEmail(state),
    currentOrderId: selectors.getCurrentOrderId(state),
    subOrderId: selectors.getSubOrderId(state),
    reviewFormValues: selectors.getReviewFormValues(state),
    pickupStoresInCart: BagPageSelector.getCartStores(state),
    isOrderHasPickup: isPickuOrderStatus(state),
    pickupInformation: selectors.getPickupValues(state),
    errorLabels: BagPageSelector.getErrorMapping(state),
    cartHaveGCItem: selectors.getIsCartHaveGiftCards(state),
    status: AfterPaySelectors.getAfterPayStatus(state),
    tokens: AfterPaySelectors.getAfterPayTokens(state),
    shipmentId: selectors.getSavedShipmentId(state),
    shippingAddressObj: selectors.getShippingValues(state),
    orderType: BagPageSelector.getOrderType(state),
    fallbackAddress: AfterPaySelectors.getFallbackAddress(state),
    fallbackUserContact: AfterPaySelectors.getFallbackUserInfo(state),
    isLoggedIn: getUserLoggedInState(state),
    userDefaultPickupStore: PickupSelectors.getUserDefaultPickupStore(state),
    shouldExpressAfterPayPopupOpen: BagPageSelector.getOpenExpressAfterPayPopup(state),
    allCouponList: getAllCoupons(state),
    couponApplied: isCouponApplied(state),
    afterPayMinOrderAmount: getAfterPayMinOrderAmount(state),
    afterPayMaxOrderAmount: getAfterPayMaxOrderAmount(state),
    selectedShippingMethod: BagPageSelector.getShippingMethod(state),
    shippingAddressState: BagPageSelector.getShippingAddressState(state),
    showCouponsDrawer: selectors.getShowCouponsDrawer(state),
    firstName: getUserName(state),
    lastName: getUserLastName(state),
    appliedCouponList: getAppliedCouponListState(state),
    freeShippingPromoType: getFreeShippingType(state),
    shipments: getOrderShipments(state),
    shippingMethodSelected: selectors.getSavedShippingMethod(state),
    freeShippingThreshold: getFreeShippingThershold(state),
    dynamicShippingCharge: getDynamicShippingCharge(state),
    dynamicShippingTax: getDynamicShippingTax(state),
    isShippingChargesApplicableForAfterPayEnabled:
      getIsShippingChargesApplicableForAfterPayEnabled(state),
    paymentMethod: BagPageSelector.getBillingPaymentMethod(state),
    cardType: selectors.getCardType(state),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    checkoutWithAfterPay: (payload) => {
      const { navigation } = ownProps;
      const submitPayload = { ...payload, navigation };
      dispatch(checkoutWithAfterPay(submitPayload));
    },
    setErrorState: (payload) => {
      dispatch(CHECKOUT_ACTIONS.setServerErrorCheckout(payload));
    },
    setLoader: (payload) => dispatch(setLoaderState(payload)),
    showSpcButtonLoader: (payload) => dispatch(setSpcButtonLoader(payload)),
    updateAppStatus: (payload) => dispatch(updateAppStatusAction(payload)),
    updateAppTokens: (payload) => dispatch(updateAppTokensAction(payload)),
    updateAppCreditCardInfo: (payload) => dispatch(updateAppCreditCardInfoAction(payload)),
    setShippingAddress: (payload) => dispatch(getSetShippingValuesActn(payload)),
    updateSelectedShippingMethodActn: (payload) => dispatch(updateSelectedShippingMethod(payload)),
    checkoutWithExpressAfterPay: (payload) => dispatch(checkoutWithExpressAfterPay(payload)),
    setAfterPayPaymentProgressActn: (payload) => {
      dispatch(setAfterPayPaymentProgress(payload));
    },
    setAfterPayPopupOpenActn: (payload) => {
      dispatch(bagPageActions.setAfterPayPopupOpen(payload));
    },
    setOrderDetailsPartial: (payload) => {
      dispatch(bagPageActions.getOrderDetailsPartial(payload));
    },
    setEstimatedTax: (payload) => {
      dispatch(bagPageActions.setEstimatedTax(payload));
    },
    setAfterPayDrawerActn: (payload) => {
      dispatch(setAfterPayDrawer(payload));
    },
    trackAnalyticsClick: (eventData, payload) => {
      dispatch(setClickAnalyticsData(eventData));
      const timer = setTimeout(() => {
        dispatch(trackClick(payload));
        clearTimeout(timer);
      }, 100);
    },
    getSetPickupValuesAction: (payload) => dispatch(getSetPickupValuesActn(payload)),
    handleRemoveCoupon: (coupon) => {
      return new Promise((resolve, reject) => {
        dispatch(
          removeCoupon({
            coupon,
            formPromise: { resolve, reject },
            fromAfterPay: 'true',
          })
        );
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AfterPayContainer);
